import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorFetchingSavedConfig: {
		id: 'servicedesk-widget-settings.content.error-fetching-saved-config',
		defaultMessage: "We can't load the widget right now. Try again in a little while.",
		description:
			'Error message displayed when there is an error fetching the saved widget configuration from the backend',
	},
	errorSavingConfig: {
		id: 'servicedesk-widget-settings.content.error-saving-config',
		defaultMessage: "We can't save the widget right now. Try again in a little while.",
		description: 'Error message displayed when there is an error saving the widget configuration',
	},
	errorValidatingRequestType: {
		id: 'servicedesk-widget-settings.content.error-validating-request-type',
		defaultMessage: "We can't validate the widget right now. Try again in a little while.",
		description:
			'Error message displayed when there is an error validating the request type from the backend',
	},
});
